module.exports = __webpack_public_path__ + "img/common_path_icon.e634e6cb.png";